import React, { useEffect, useState, useRef, useCallback } from "react";
import nodata from "../../assets/img/no-data.svg";
import { directAffiliateList } from "../../api/apiService";
import { useToken } from "../../components/TokenContext";

import  Loader from "../../components/Loader";
const DirectAffiliates = () => {



  // State for mobile filter visibility
  const [showFilter, setShowFilter] = useState(false);

  // Functions to toggle/close filter
  const toggleFilter = () => setShowFilter(!showFilter);
  const closeFilter = () => setShowFilter(false);




  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [status, setStatus] = useState("");
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [copiedWallet, setCopiedWallet] = useState(null);
  const [searchField, setSearchField] = useState("");
  const [searchValue, setSearchValue] = useState("");

  const { token, fetchToken } = useToken();

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  const rowsPerPage = process.env.REACT_ROW_PER_PAGE || 100;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const formatBalance = (balance) => balance ? parseFloat(balance).toLocaleString(): "0.00";

  // Format DateTime
  const formatDateTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return date.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      // hour: "2-digit",
      // minute: "2-digit",
      // second: "2-digit",
      // hour12: true,
    });
  };

  const copyWallet = (wallet) => {
    navigator.clipboard.writeText(wallet);
    setCopiedWallet(wallet);
    setTimeout(() => setCopiedWallet(null), 2000);
  };

  // Fetch Wallet Statement
  const fetchDirectAffiliates = useCallback(
    async (page, searchField, searchValue) => {
      setLoading(true);
      try {
        // Make Sure We Have Token
        let currentToken = token || (await fetchToken());
        if (!currentToken) return;
        const loginToken = localStorage.getItem("LoginToken") || currentToken;
        const response = await directAffiliateList(
          currentToken,
          loginToken,
          page,
          rowsPerPage,
          searchField,
          searchValue,
          fromDate,
          toDate
        );
        if (response.status) {
          const dataList = response.DataList || [];
          setTableData(dataList);
          setTotalRecords(response.TotalRecords || dataList.length);
        } else {
          setTableData([]);
          setTotalRecords(0);
        }
      }
      catch (error) {
        setTableData([]);
        setTotalRecords(0);
      }
      finally {
        setLoading(false);
      }
    },
    [fromDate, toDate, token, fetchToken]
  );


  // Initial Load & Whenever Page Changes
  useEffect(() => {
    fetchDirectAffiliates(currentPage, searchField, searchValue);
  }, [fetchDirectAffiliates, currentPage]);

  // Handle Search
  const handleSearch = () => {
    const page = 1;
    setCurrentPage(page);
    fetchDirectAffiliates(page, searchField, searchValue); // Pass Values Directly
  };

  // Handle Reset
  const handleReset = () => {
    setFromDate("");
    setToDate("");
    setSearchField("");
    setSearchValue("");
    const page = 1;
    setCurrentPage(page);
    fetchDirectAffiliates(page, "", ""); // Reset Search
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (

    <div className="buyshheikh-page">
      <div className="pageTitle">Direct Affiliates
        {/* Mobile Filter Button */}
        <button
          className="mobile-filter-btn d-md-none"
          onClick={toggleFilter}
        >
          Filter <i className="fa fa-filter"></i>
        </button> </div>
      <div className="card mb-3">
        <div className="card-body">

          {/* Filters */}

          {showFilter && <div className="overlay" onClick={closeFilter}></div>}

          {/* Filter Card */}
          <div className={`filter-card ${showFilter ? "show" : ""}`}>
            <span className="badge bg-danger closefilter-btn" onClick={closeFilter} >   <i class="fa-solid fa-xmark"></i></span>
            <div className="row">
              {/* From Date */}
              <div className="col-md-6 col-lg-2  mb-3">
                <label htmlFor="fromDate" className="form-label">From Date</label>
                <div className="input-icon">
                  <input
                    ref={fromDateRef}
                    type="date"
                    id="fromDate"
                    className="form-control form-control-new no-calendar-icon"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    onClick={() => fromDateRef.current?.showPicker()}
                  />
                  <i className="fa-solid fa-calendar iconposition"></i>
                </div>
              </div>

              {/* To Date */}
              <div className="col-md-6 col-lg-2  mb-3">
                <label htmlFor="toDate" className="form-label">To Date</label>
                <div className="input-icon">
                  <input
                    ref={toDateRef}
                    type="date"
                    id="toDate"
                    className="form-control form-control-new no-calendar-icon"
                    value={toDate}
                    onChange={(e) => setToDate(e.target.value)}
                    onClick={() => toDateRef.current?.showPicker()}
                  />
                  <i className="fa-solid fa-calendar iconposition"></i>
                </div>
              </div>

              <div className="col-md-6 col-lg-2  mb-3">
                <div className="form-group">
                  <label htmlFor="network" className="form-label">Search By</label>
                  <div className="input-icon">
                    <select className="form-control form-control-new" value={searchField}
                      onChange={(e) => setSearchField(e.target.value)} >
                      <option value="">Search By</option>
                 {/*      <option value="Name">Name</option>
                      <option value="Email">Email</option>
                      <option value="Mobile">Mobile</option> */}
                      <option value="Wallet">Wallet</option>
                    </select>
                    <i className="fa-solid fa-magnifying-glass iconposition"></i>
                  </div>
                </div>
              </div>

              <div className="col-md-6 col-lg-3  mb-3">
                <div className="form-group">
                  <label htmlFor="hash" className="form-label">Search Value</label>
                  <div className="input-icon">
                    <input type="text" className="form-control form-control-new" value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)} />
                    <i className="fa-solid fa-hashtag iconposition"></i>
                  </div>
                </div>
              </div>



              {/* Buttons */}
              <div className="col-md-6 col-lg-3  mb-3">
                <label className="visibilty-hidden form-label">Search</label>
                <div className="d-flex gap-2">
                  <button className="btn btn-success" onClick={handleSearch}>Search</button>
                  <button className="btn btn-danger" onClick={handleReset}>Reset</button>
                </div>
              </div>
            </div>

          </div>

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-striped table-bordered mytable">
              <thead className="table-dark">
                <tr>
                  <th>S.No.</th>
                  <th>Date</th>
                   {/* <th>Login Id</th>
                  <th>Email Id</th>
                   <th>Name</th> */}
                  <th>Wallet</th>
                  <th>Purchased Amount($)</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                     
                    
          <Loader />
                    
                    </td>
                  </tr>
                ) : tableData.length ? (
                  tableData.map((row) => (
                    <tr key={row.RowNumber}>
                      <td>{row.RowNumber}</td>
                      <td>{formatDateTime(row.DATE)}</td>
                    {/*   <td>{row.LOGINID}</td>
                      <td>{row.PersonaEmailId}</td>
                      <td>{row.NAME}</td> */}
                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <span>{row.WALLETADDRESS}</span>
                          <span
                            className="copy-walletaddress"
                            onClick={() => copyWallet(row.WALLETADDRESS)}
                          >
                            <i className={`fa ${copiedWallet === row.WALLETADDRESS ? "fa-check" : "fa-copy"}`}></i>
                          </span>
                        </div>
                      </td>
                      <td>
                        <span
                          style={{
                            display: "inline-block",
                            padding: "4px 10px",
                            borderRadius: "5px",
                            color: "white",
                            backgroundColor: "rgb(56 81 69)",
                            minWidth: "60px",
                            textAlign: "center",
                          }}
                        >
                           ${formatBalance(row.BUSINESS)}
                        </span>
                      </td>

                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      {/* <img src={nodata} className="not-data" alt="No Data" /> */}
                      <div>No records found</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {tableData.length > 0 && (
            <div className="d-flex justify-content-between align-items-center mt-2">
              <div>
                Showing {(currentPage - 1) * rowsPerPage + 1} to{" "}
                {currentPage * rowsPerPage > totalRecords ? totalRecords : currentPage * rowsPerPage} of {totalRecords} entries
              </div>
              <div>
                <ul className="pagination mb-0">
                  <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => paginate(currentPage - 1)}>Previous</button>
                  </li>
                  {[...Array(totalPages)].map((_, idx) => (
                    <li key={idx} className={`page-item ${currentPage === idx + 1 ? "active" : ""}`}>
                      <button className="page-link" onClick={() => paginate(idx + 1)}>{idx + 1}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button className="page-link" onClick={() => paginate(currentPage + 1)}>Next</button>
                  </li>
                </ul>
              </div>
            </div>
          )}

        </div>
      </div>
    </div>

  );
};

export default DirectAffiliates;


